// src/contexts/CookieUiContext.tsx
"use client";

import React, { createContext, useContext, useState } from "react";
import CookieModal from "@/components/cookie-consent/CookieModal";
import CookiePolicyPopup from "@/components/cookie-consent/CookiePolicyPopup";

type CookieUiContextType = {
  openPreferences: () => void;
  openPolicy: () => void;
  closeAll: () => void;
};

const CookieUiContext = createContext<CookieUiContextType | null>(null);

export function CookieUiProvider({ children }: { children: React.ReactNode }) {
  const [showPreferences, setShowPreferences] = useState(false);
  const [showPolicy, setShowPolicy] = useState(false);

  const closeAll = () => {
    setShowPreferences(false);
    setShowPolicy(false);
  };

  const openPreferences = () => {
    setShowPolicy(false);
    setShowPreferences(true);
  };

  const openPolicy = () => {
    setShowPreferences(false);
    setShowPolicy(true);
  };

  return (
    <CookieUiContext.Provider value={{ openPreferences, openPolicy, closeAll }}>
      {children}

      {(showPolicy || showPreferences) && (
        <div
          className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 backdrop-blur-md"
          role="dialog"
          aria-modal="true"
          onClick={closeAll} // click outside closes
        >
          {showPolicy && (
            <CookiePolicyPopup
              onClose={closeAll}
              onManagePreferences={() => openPreferences()}
            />
          )}

          {showPreferences && <CookieModal onClose={closeAll} />}
        </div>
      )}
    </CookieUiContext.Provider>
  );
}

export function useCookieUi() {
  const ctx = useContext(CookieUiContext);
  if (!ctx) throw new Error("useCookieUi must be used within CookieUiProvider");
  return ctx;
}
